import React from "react";
import { Field, reduxForm, focus } from "redux-form";
import { registerUser } from "../actions/users";
import { login } from "../actions/auth";
import Input from "./input";
import { required, nonEmpty, matches, length, isTrimmed } from "../validators";
import "./register.css";
const passwordLength = length({ min: 6, max: 72 });
const matchesPassword = matches("password");

export class RegistrationForm extends React.Component {
    onSubmit(values) {
        const { username, password } = values;
        const user = { username, password };
        return this.props
            .dispatch(registerUser(user))
            .then(() => this.props.dispatch(login(username, password)));
    }

    render() {
        return (
            <form
                className="registration-form"
                onSubmit={this.props.handleSubmit(values =>
                    this.onSubmit(values)
                )}
            >
                <h2>Register</h2>
                <label htmlFor="username">Username</label>
                <Field
                    component={Input}
                    type="text"
                    name="username"
                    validate={[required, nonEmpty, isTrimmed]}
                />
                <label htmlFor="password">Password</label>
                <Field
                    component={Input}
                    type="password"
                    name="password"
                    validate={[required, passwordLength, isTrimmed]}
                />
                <label htmlFor="passwordConfirm">Confirm password</label>
                <Field
                    component={Input}
                    type="password"
                    name="passwordConfirm"
                    validate={[required, nonEmpty, matchesPassword]}
                />
                <button
                    type="submit"
                    disabled={this.props.pristine || this.props.submitting}
                >
                    Submit
                </button>
            </form>
        );
    }
}

export default reduxForm({
    form: "registration",
    onSubmitFail: (errors, dispatch) =>
        dispatch(focus("registration", Object.keys(errors)[0]))
})(RegistrationForm);



// WEBPACK FOOTER //
// ./src/components/registration-form.js